export enum EFeedbackWidgetEvents {
  widgetActivated = 'user_activated_feedback_widget',
}
